import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ky from 'ky';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { TextField, Button, Typography, Grid } from '@material-ui/core';

import { setSnackbar, getLoginCheckData } from '../redux/workBackendSlice';
import { PublishDataType } from '../hooks/useMakePublishData';

import { Hash, setTokensToCookie } from '../general';
import { formatVersion } from '.';
import { apiURL } from '../components/DigimagiProvider';
import { GoodsDataType } from './PublishDialog';

type SelectVersionDialogProps = {
  open: boolean;
  onClose: (done: boolean) => void;
  goodsData?: GoodsDataType;
  updateData?: Hash<Object>;
  thisVersion?: number;
  publishData?: PublishDataType;
}
const SelectVersionDialog: React.FC<SelectVersionDialogProps> = (props) => {
  const dispatch = useDispatch();
  const { open, onClose, goodsData, updateData, thisVersion, publishData } = props;
  const [major, setMajor] = useState('');
  const [minor, setMinor] = useState('');
  const [patch, setPatch] = useState('');
  const [pickedMajorLatest, setPickedMajorLatest] = useState<number>();
  const [errMessage, setErrMessage] = useState<string>();

  const clearState = (done: boolean) => {
    onClose(done);
  }
  const getVersionPart = (version: number, where: 'major' | 'minor' | 'patch'): string => {
    const str = version.toString();
    const len = str.length;

    if (len < 3) {
      throw new Error("Input number must be at least 3 digits");
    }

    let part: string;
    if (where === 'major') part = str.slice(0, len - 4) || "0"; // メジャーバージョン
    else if (where === 'minor') part = str.slice(Math.max(0, len - 4), len - 2).replace(/^0+/, '') || "0"; // マイナーバージョン
    else part = str.slice(len - 2).replace(/^0+/, '') || "0"; // 先頭の0を削除
    return part;
  }
  const checkVersion = (version: number) => {
    if (!thisVersion || !goodsData) return;
    const latest = goodsData.otherLatestsInfo.find(info => Math.trunc(info[0] / 10000) === Math.trunc(version / 10000));
    if (latest) setPickedMajorLatest(latest[0]);
    else setPickedMajorLatest(undefined);

    if (version <= thisVersion) setErrMessage('現在のバージョン以下のバージョンは指定できません。');
    else if (latest && version <= latest[0]) setErrMessage('各メジャーバージョンの最新以下のバージョン番号は指定できません。');
    else setErrMessage(undefined);
  }
  const parseVersion = (version: string): number | string => {
    const parts = version.split(".");

    if (parts.length !== 3) {
      setErrMessage('無効なバージョン番号です。');
      return '-';
    }

    const [major, minor, patch] = parts.map(Number);

    if ([major, minor, patch].some(isNaN)) {
      setErrMessage('数値以外は指定できません。')
      return '-';
    }

    return major * 10000 + minor * 100 + patch;
  }
  const changeVersionNumber = (value: string, where: 'major' | 'minor' | 'patch') => {
    if (!thisVersion) return;
    else if (value === '') {
      setErrMessage('半角数字で入力してください。');
      return;
    } else if (value.slice(0, 1) === '-') {
      setErrMessage('0未満の数字は使用できません。');
      return;
    }
    let version: number | string;
    if (where === 'major') {
      version = parseVersion(`${value}.${minor}.${patch}`);
      setMajor(value);
    } else if (where === 'minor') {
      version = parseVersion(`${major}.${value}.${patch}`);
      setMinor(value);
    } else {
      version = parseVersion(`${major}.${minor}.${value}`);
      setPatch(value);
    }
    if (typeof version === 'number') checkVersion(version);
  }
  const updateExe = async () => {
    if (!goodsData) return;
    try {
      const version = parseVersion((`${major}.${minor}.${patch}`));
      if (typeof version === 'string') throw new Error('無効なバージョン番号です。');
      console.log(version)
      console.log(goodsData)
      console.log(updateData)
      console.log(publishData)
      const loginCheckData = getLoginCheckData();
      const isUpgrade = Math.trunc(version / 10000) > Math.trunc(goodsData.allLatestInfo[0] / 10000);
      const hash = isUpgrade ? publishData : updateData;
      const sendData = { ...loginCheckData, goodsId: goodsData.goods.id, version, hash };
      const query = await ky.post(`${apiURL}update_goods_items`, { json: sendData }).json() as any;
      console.log(query.data)
      const newToken = query.data;
      if (newToken && typeof newToken === 'object') setTokensToCookie(newToken);
      dispatch(setSnackbar({ open: true, message: `${goodsData?.goods.name} をアップデートしました` }))
      clearState(true);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (!thisVersion || !goodsData) return;
    console.log(updateData)
    console.log(publishData)
    console.log(goodsData)
    setMajor(getVersionPart(thisVersion, 'major'));
    setMinor(getVersionPart(thisVersion, 'minor'));
    setPatch(getVersionPart(thisVersion, 'patch'));

    const version = parseVersion(`${major}.${minor}.${patch}`);
    if (typeof version === 'number') checkVersion(version);
  }, [open, updateData])

  if (thisVersion === undefined) return <></>;
  return (
    <Dialog open={open} onClose={() => clearState(false)}>
      <DialogTitle>バージョンを指定してアップデートする</DialogTitle>
      <DialogContent>
        { goodsData &&
          <div>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Typography variant="caption">現在のバージョン</Typography>
                <Typography variant="body1">{ formatVersion(thisVersion) }</Typography>
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 32 }}>
              <Grid item xs={6}>
                <Typography variant="caption">最新の同一メジャーバージョン</Typography>
                <Typography variant="body1">{ formatVersion(goodsData.majorLatestInfo[0]) }</Typography>
                <Typography variant="body1">{ goodsData.majorLatestInfo[2] }（{ goodsData.majorLatestInfo[1] }）</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption">最新バージョン</Typography>
                <Typography variant="body1">{ formatVersion(goodsData.allLatestInfo[0]) }</Typography>
                <Typography variant="body1">{ goodsData.allLatestInfo[2] }（{ goodsData.allLatestInfo[1] }）</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: 64 }}>
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}><Typography variant="caption">新しいバージョン</Typography></Grid>
                  <Grid item xs={12}><Typography variant="caption">（ 現最新</Typography></Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <Grid container>
                  <Grid item xs={12}><Typography variant="body1" style={{ color: errMessage ? 'red': undefined }}>{ `${major}.${minor}.${patch}` }</Typography></Grid>
                  <Grid item xs={12}><Typography variant="body1">{ pickedMajorLatest ? formatVersion(pickedMajorLatest) : '-' } ）</Typography></Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}><Typography variant="caption" style={{ color: 'red' }}>{ errMessage }</Typography></Grid>
              <Grid item xs={4}>
                <TextField type="number" label="メジャーバージョン" variant="outlined"
                  defaultValue={getVersionPart(thisVersion, 'major')}
                  onChange={ev => changeVersionNumber(ev.currentTarget.value, 'major')}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField type="number" label="マイナーバージョン" variant="outlined"
                  defaultValue={getVersionPart(thisVersion, 'minor')}
                  onChange={ev => changeVersionNumber(ev.currentTarget.value, 'minor')}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField type="number" label="パッチバージョン" variant="outlined"
                  defaultValue={getVersionPart(thisVersion, 'patch')}
                  onChange={ev => changeVersionNumber(ev.currentTarget.value, 'patch')}
                />
              </Grid>
            </Grid>
          </div>
        }
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => clearState(false)} size="large">
          キャンセル
        </Button>
        <Button color="primary" onClick={updateExe} size="large" disabled={Boolean(errMessage)}>
          アップデートする
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectVersionDialog;
